"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemPrice = void 0;
var _mui = require("@ori-ui/mui");
var _context = require("../../context");
var _FormattedPoints = require("./FormattedPoints");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
const Price = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    arePointsShown,
    isOfferColor,
    isAvailable
  },
  theme
}) => ({
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.primary,
  ...((Boolean(isOfferColor) || arePointsShown) && {
    color: theme.palette.offer.main
  }),
  ...(!isAvailable && {
    color: theme.palette.text.secondary
  }),
  fontWeight: 'bold',
  display: 'flex'
}));
const Plus = (0, _mui.styled)('span')(({
  theme
}) => ({
  color: theme.palette.offer.main,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 'bold',
  '&:after': {
    content: '"+"'
  }
}));
const ItemPrice = () => {
  const {
    isAvailable,
    isOfferColor,
    itemTestId,
    points,
    totalPrice
  } = (0, _context.useItemContext)();
  const arePointsShown = Boolean(points && points !== '');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.NumberInner, {
    "data-testid": `${itemTestId}-price`,
    children: [arePointsShown ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedPoints.FormattedPoints, {
        children: points
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Plus, {})]
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(Price, {
      ownerState: {
        arePointsShown,
        isOfferColor,
        isAvailable
      },
      children: totalPrice
    })]
  });
};
exports.ItemPrice = ItemPrice;
